import ResultText from "../ResultText";
import ResultView from "../../../components/ResultView";

export function CFL2({data, message_key}) {
    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({row, globalVariables}) => {
    const baseFregime = row?.data?.[0]?.base_fregime || 'None';
    const compFregime = row?.data?.[0]?.comp_fregime || 'None';

    return (
        <ResultText>
            The flow regime is changed from <b>{baseFregime}</b> to <b>{compFregime}</b>.
        </ResultText>
    );
}
